import styled from "styled-components";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as SortFilter from "../../top-bar/styles/SortFiltersStyles";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";

export const Viewport = styled.div`
    display: flex;
    flex: 1 1 auto;
    max-width: 100%;
    padding: 0;
    padding-bottom: ${theme.space[2]}px;
    text-align: start;
    overflow-y: hidden;

    @media ${getBreakpoint("up", "md")} {
        overflow-y: visible;
    }

    @media ${getBreakpoint("up", "lg")} {
        max-width: none;
        text-align: center;
        overflow-y: visible;

        &::after {
            display: none;
        }
    }
`;

export const Wrapper = styled.div`
    position: relative;
    justify-content: center;
    width: 100%;
    padding: ${theme.space[3]}px 0;

    ${SortFilter.Wrapper} {
        padding-bottom: ${theme.space[1]}px;
        padding-right: ${theme.space[1]}px;

        @media ${getBreakpoint("down", "lg")} {
            display: none;
        }
    }

    @media ${getBreakpoint("up", "lg")} {
        flex-wrap: wrap;
        margin: 0 auto;
    }

    html[dir="rtl"] & {
        ${SortFilter.Wrapper} {
            padding-left: ${theme.space[1]}px;
            padding-right: 0;
        }
    }
`;

export const Pills = styled.div`
    padding: 0 ${theme.space[2]}px;
`;

export const MobileFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: ${theme.space[3]}px ${theme.space[3]}px 0;

    ${Button.ButtonTertiary} {
        max-width: 50%;

        /* Fix mobile style */
        button {
            max-width: 100%;
            overflow-x: hidden;
            text-overflow: ellipsis;
        }
    }

    @media ${getBreakpoint("up", "lg")} {
        display: none;
    }
`;

export const DesktopFooter = styled.div`
    display: flex;
    position: relative;
    justify-content: center;
    width: 100%;
    padding-top: ${theme.space[3]}px;

    @media ${getBreakpoint("down", "lg")} {
        display: none;
    }
`;

export const FilterCount = styled.div``;

export const RemoveButton = styled.button`
    ${IconWrapper} {
        margin-left: ${theme.space[1]}px;
    }

    html[dir="rtl"] & {
        ${IconWrapper} {
            margin-left: 0;
            margin-right: ${theme.space[1]}px;
        }
    }
`;
